import actions from '@synergycms_app/store/actions';
import {filter} from 'ramda';
import { api } from '../../utils';

export default {
  CURRENCIES: {
    GET_ASYNC : (inputList) => (dispatch, getState) => {
      const store = getState();
      // return empty promise if currencies are already loaded
      if (store.getIn(['customer', 'currencies']).size) {
        return Promise.resolve();
      }
      // load currencies
      return api.get('data/currencies_avail').then((response) => {
        dispatch(actions.customer.currencies.get(response));
        dispatch(actions.customer.mainCurrencies.get(filter((currency) => currency.main, response)));
      });
    },
    GET: currencies => {
      return currencies;
    }
  },
  MAIN_CURRENCIES: {
    GET: mainCurrencies => {
      return mainCurrencies;
    }
  },
  CURRENT_CURRENCY: {
    SET: (currencyCode, forceUpdate = false) => {
      return (dispatch, getState) => {
        let finalCurrency;
        const store = getState();
        const currencyParam = store.getIn(['customer', 'params', 'url_params', 'currency'], false);

        const currencies = store.getIn(['customer', 'currencies']);
        const previousCurrency = store.getIn(['customer', 'current_currency']);
        const validateCurrency = currencyCode => currencies.find(c => currencyCode === c.get('code'));
        if (currencyCode && validateCurrency(currencyCode)) {
          finalCurrency = currencyCode;
        } else if (currencyParam && validateCurrency(currencyParam)) {
          finalCurrency = currencyParam;
        } else {
          if (previousCurrency && validateCurrency(previousCurrency)) {
            finalCurrency = previousCurrency;
          }
          if (store.getIn(['customer', 'step', 'current_step', 'code']) !== 'multiHotelAvail') {
            const hotelId = store.getIn(['customer', 'current_hotel']);
            const hotelCurrency = store.getIn(['hotels', hotelId, 'currency', 'code'], false);
            if (hotelCurrency && validateCurrency(hotelCurrency)) {
              finalCurrency = hotelCurrency;
            }
          } else {
            const firstHotel = store.get('hotels').find((h, key) => {
              return !isNaN(parseInt(key, 10)) && h.get('success');
            });
            if (firstHotel) {
              finalCurrency = firstHotel.getIn(['currency', 'code'], null);
            }
          }
        }
        return finalCurrency;
      };
    }
  }
};
